import { Component, OnInit, OnDestroy } from '@angular/core';
import { VoiceNavigationService, VoiceCommand } from '../../../services/app/voice-navigation/voice-navigation.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-voice-navigation',
  templateUrl: './voice-navigation.component.html',
  styleUrls: ['./voice-navigation.component.css']
})
export class VoiceNavigationComponent implements OnInit, OnDestroy {
  isListening = false;
  lastCommand = '';
  isSupported = false;
  showHelp = false;
  availableCommands: VoiceCommand[] = [];

  constructor(private voiceNavigationService: VoiceNavigationService) {}

  ngOnInit(): void {
    this.isSupported = this.voiceNavigationService.isVoiceSupported();
    this.availableCommands = this.voiceNavigationService.getAvailableCommands();

    this.voiceNavigationService.getIsListening()
      .pipe(untilDestroyed(this))
      .subscribe(isListening => {
        this.isListening = isListening;
      });

    this.voiceNavigationService.getLastCommand()
      .pipe(untilDestroyed(this))
      .subscribe(command => {
        this.lastCommand = command;
        // Clear the command after 3 seconds
        setTimeout(() => {
          this.lastCommand = '';
        }, 3000);
      });
  }

  toggleListening(): void {
    this.voiceNavigationService.toggleListening();
  }

  toggleHelp(): void {
    this.showHelp = !this.showHelp;
  }

  ngOnDestroy(): void {
    // Component will be automatically cleaned up by @UntilDestroy()
  }
} 